import { Game } from "./pages/Game";

function App() {
  return (
    <div>
      <Game />
    </div>
  );
}

export default App;
